/**
 * Utility functions for handling video objects from Go's sql.NullString
 */

export type VideoObject = {
  String: string;
  Valid: boolean;
};

/**
 * Extracts the video URL from either a string or null
 * @param video - Can be a string URL or null
 * @returns The video URL string or undefined if not valid
 */
export function extractVideoUrl(video?: string | null): string | undefined {
  if (!video || video === null) return undefined;
  
  if (typeof video === 'string') {
    return video;
  }
  
  return undefined;
}

/**
 * Checks if a video object is valid and has content
 * @param video - Can be a string URL or null
 * @returns true if video is valid and has content
 */
export function hasValidVideo(video?: string | null): boolean {
  const videoUrl = extractVideoUrl(video);
  return Boolean(videoUrl && videoUrl !== "");
}
